export var PremiseType;
(function (PremiseType) {
    PremiseType[PremiseType["None"] = 0] = "None";
    PremiseType[PremiseType["OwnPremises"] = 1] = "OwnPremises";
    PremiseType[PremiseType["RelatedOrganisationPremises"] = 2] = "RelatedOrganisationPremises";
    PremiseType[PremiseType["Rental"] = 3] = "Rental";
    PremiseType[PremiseType["MunicipalityPremises"] = 4] = "MunicipalityPremises";
    PremiseType[PremiseType["Other"] = 5] = "Other";
})(PremiseType || (PremiseType = {}));
